<template>
  <div class="circle_list" v-if="circletrends.length > 0">
    <div
      class="circle_item"
      v-for="(item, index) in circletrends"
      :data-index="index"
    >
      <div class="circle_item_av">
        <img
          :src="
            item.avatarUrl ? item.avatarUrl : '../../static/user/icon_1.png'
          "
        />
      </div>
      <div class="circle_item_info">
        <div class="info_name">{{ item.nickname }}</div>
        <div class="info_title">{{ item.title }}</div>
        <div class="info_imgs" v-if="item.imgUrlJson !='[null]'">
          <div
            class="imgs"
            :class="{ imgs_50: JSON.parse(item.imgUrlJson).length == 1 }"
            v-for="(item_1, index_1) in JSON.parse(item.imgUrlJson)"
            :style="{ backgroundImage: 'url(' + item_1.filepath + ')' }"
          >
         
            <el-image
              class="my-img"
              v-if="item_1.filepath"
              :src="item_1.filepath"
              :preview-src-list="getimgArr(index)"
              :z-index="index_1"
            >
            </el-image>
          </div>
        </div>
        <div class="info_time">{{ item.createdAt }}</div>
        <div class="info_tag">
          <div class="tag">#{{ item.datatype }}#</div>
          <div
            class="likes"
            @click="golikes(item.id, index)"
            :data-index="index"
            :data-id="item.id"
          >
            <img class="red" src="../../static/circle/red.png" />{{
              item.like_num
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="circle_list" v-else>
    <div class="no_data">
      <div class="no_icon"></div>
      <div class="no_text">暂无数据</div>
    </div>
  </div>
</template>

<script>
import { getdolike } from "../view/api/api"; //引入api里面定义的方法
export default {
  props: ["circletrends"],
  data() {
    return {};
  },
  methods: {
    
    getimgArr(index){
      var circletrends = this.circletrends;
        var imgs=circletrends[index];
        var imgobjs=JSON.parse(imgs.imgUrlJson)
        //console.log(imgobjs);
        let imgArr=[];
        for(let item in imgobjs){imgArr.push(imgobjs[item].filepath) } 
        
        return imgArr;
    },
    async golikes(id, index) {
      //console.log(e);
      var that = this;
      //console.log(this.circletrends);
      var circletrends = this.circletrends;
      //var id = id;
      //var index = index;

      var data = {
        uid: localStorage.getItem("userId"),
        did: id
      };
      const res = await getdolike(data);
      if (res.status == 1) {
        this.$toast("点赞成功");
        circletrends[index].like_num =
          parseInt(circletrends[index].like_num) + 1;
        that.circletrends = circletrends;
      } else {
        //this.$message(res.msg);
      }
    }
    // 预览图片多张
  }
};
</script>

<style lang="less" scoped>
.circle_list {
  margin: 0.4rem auto;
  width: 90%;
  @media (max-width: 991px) {
    width: 100%;
  }
  flex-direction: column;
  .circle_item {
    border-bottom: 0.01rem solid rgba(196, 196, 204, 0.1);
    padding-bottom: 0.18rem;
    margin-bottom: 0.2rem;
    display: flex;

    .circle_item_av {
      width: 0.8rem;
      margin-right: 0.2rem;
      img {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 50%;
      }
      .info_name {
        width: 0.8rem;
        font-size: 0.14rem;
        color: #80c1e8;
        line-height: 0.25rem;
        margin-bottom: 0.05rem;
        padding: 0.12rem;
        overflow: hidden;
        word-wrap: break-word;
        @media (max-width: 991px) {
          font-size: 0.2rem;
          line-height: 0.3rem;
        }
      }
    }

    .circle_item_info {
      width: ~"calc(100% - 1rem)";
      flex-direction: column;
      display: flex;
      text-align: left;

      .info_name {
        font-size: 0.16rem;
        color: #80c1e8;
        line-height: 42rpx;
        margin-bottom: 5rpx;
        @media (max-width: 991px) {
          font-size: 0.26rem;
          line-height: 0.28rem;
        }
      }

      .info_title {
        font-size: 0.18rem;
        color: #1b1c33;
        line-height: 0.26rem;
        margin-bottom: 0.15rem;
        @media (max-width: 991px) {
          font-size: 0.3rem;
          line-height: 0.42rem;
        }
      }

      .info_imgs {
        flex-wrap: wrap;
        display: flex;
        width: 4.5rem;
        @media (max-width: 991px) {
          width: 100%;
        }
        .imgs {
          width: 1.2rem;
          height: 1.2rem;
          margin-right: 0.1rem;
          margin-bottom: 0.1rem;
          border-radius: 0rpx;
          position: relative;
          display: inline-block;
          background-size: cover !important;
          background-repeat: no-repeat !important;
          background-position: center center !important;
          border: 0rpx solid #f2f2f2;
          @media (max-width: 991px) {
            width: 1.8rem;
            height: 1.8rem;
          }

          img {
            width: 100%;
            height: 100%;
            border-radius: 0rpx;
            opacity: 0;
          }
        }
        .imgs_50 {
          width: 1.2rem;
          height: 1.2rem;
          overflow: hidden;
          @media (max-width: 991px) {
            width: 3rem;
            height: 3rem;
            .el-image {
              @media (max-width: 991px) {
                width: 3rem;
                height: 3rem;
              }
            }
          }
        }
        .el-image {
          width: 1.2rem;
          height: 1.2rem;
          opacity: 0;
          @media (max-width: 991px) {
            width: 1.8rem;
            height: 1.8rem;
          }
        }
      }

      .info_time {
        font-size: 0.14rem;
        color: #5e5e66;
        line-height: 0.25rem;
        margin-bottom: 0.05rem;
        @media (max-width: 991px) {
          font-size: 0.26rem;
          line-height: 0.38rem;
        }
      }

      .info_tag {
        justify-content: space-between;
        display: flex;

        .tag {
          font-size: 0.16rem;
          color: #80c1e8;
          line-height: 0.25rem;
          @media (max-width: 991px) {
            font-size: 0.26rem;
            line-height: 0.38rem;
          }
        }

        .likes {
          cursor: pointer;
          font-size: 0.2rem;
          color: #ff545a;
          line-height: 0.3rem;
          align-items: center;
          justify-content: center;
          display: flex;
          .red {
            margin-right: 0.05rem;
            width: 0.2rem;
            height: 0.2rem;
            @media (max-width: 991px) {
              width: 0.28rem;
              height: 0.28rem;
            }
          }
          @media (max-width: 991px) {
            font-size: 0.28rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/circle-list.vue